import * as React from 'react'
import QRCode from 'qrcode'
import type { OrderLink } from '@/pages/OrderLinkPage'

export function AttendeeQrCode({ attendee }: { attendee: OrderLink['attendees'][number] }) {
  const [dataUrl, setDataUrl] = React.useState<string>()
  const label = attendee.name || `Seat ${attendee.seat}`

  React.useEffect(() => {
    if (!attendee.check_in_token) return

    let active = true
    QRCode.toDataURL(attendee.check_in_token, {
      errorCorrectionLevel: 'M',
      margin: 1,
      width: 96,
    }).then((url) => {
      if (active) setDataUrl(url)
    })
    return () => {
      active = false
    }
  }, [attendee.check_in_token])

  return (
    <div className="mt-3 flex items-center gap-3" aria-label={`${label} check-in code`}>
      {dataUrl ? (
        <img
          src={dataUrl}
          alt={`${label} QR code`}
          className="h-20 w-20 rounded border border-border bg-white p-1"
        />
      ) : (
        <div
          className="h-20 w-20 animate-pulse rounded border border-border bg-muted"
          role="status"
          aria-label={`Loading ${label} QR code`}
        />
      )}
      <div>
        {!attendee.name && <p className="text-caption font-medium text-foreground">{label}</p>}
        <p className="text-caption text-muted-foreground">Scan at the door</p>
      </div>
    </div>
  )
}
